import { type TokenGroup } from "../../types";

export const effects = {
  name: "effects",
  variables: {
    "alpha-(15)": {
      type: "color",
      value: { dark: "#00000026", light: "#ffffff26" },
    },
    "alpha-(60)": {
      type: "color",
      value: { dark: "#00000099", light: "#00000099" },
    },
    "alpha-(80)": {
      type: "color",
      value: { dark: "#000000cc", light: "#000000cc" },
    },
    "alpha-dark-(80)": {
      type: "color",
      value: { dark: "#1a1a1acc", light: "#1a1a1acc" },
    },
    "background-blur": {
      type: "color",
      value: { dark: "#212121e5", light: "#ffffffe5" },
    },
    "black-transparency": {
      type: "color",
      value: { dark: "#00000000", light: "#00000000" },
    },
    border: { type: "color", value: { dark: "#3333334d", light: "#dcdcdc4d" } },
    "scrim-(30)": {
      type: "color",
      value: { dark: "#2d2d2d4d", light: "#dcdcdc4d" },
    },
    "scrim-(60)": {
      type: "color",
      value: { dark: "#0f0f0f99", light: "#0f0f0f99" },
    },
    "transparent-blur-(85-sidebar)": {
      type: "color",
      value: { dark: "#2c2c2cd9", light: "#efefefd9" },
    },
    "transparent-blur-(85)": {
      type: "color",
      value: { dark: "#1a1a1ad9", light: "#ffffffd9" },
    },
    "transparent-blur-(90)": {
      type: "color",
      value: { dark: "#1a1a1ae5", light: "#ffffffe5" },
    },
    "white-transparency": {
      type: "color",
      value: { dark: "#20202000", light: "#ffffff00" },
    },
  },
} as const satisfies TokenGroup<"effects">;
